module.exports = __webpack_public_path__ + "f8939366daf6dbbb7185f34a01787a50.svg";